// extracted by mini-css-extract-plugin
export default {"root":"CO32Xy","icon":"O1zwB8","checkmark":"DQXFXE","label":"P4HRnF","tooltipWrapper":"m773bW","showTooltip":"zfFt8g","copyButtonWrapper":"xLCoEb","visuallyHidden":"QBfnPR"};